import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader } from "../Helpers";
import {
  STR_CHANGE_PHONE_NUMBER,
  STR_CONSULTATION_FEE_PAYMENTS,
  STR_CONTACT_US,
  STR_EMAIL,
  STR_INVALID_EMAIL,
  STR_INVALID_PHONE,
  STR_OPERATION_FAILED,
  STR_PAYMENT_SETTINGS,
  STR_PERSONAL_SETTINGS,
  STR_PHONE_NUMBER,
  STR_SUBMIT,
  STR_SUBSCRIPTION_FEE_PAYMENTS,
  STR_SUCCESS,
  STR_UPDATE_PERSONAL_INFO,
  STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";

export default function PersonalInfoUpdater(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [phone, setPhone] = useState(appContext.currentUserData.userPhone);
  const [email, setEmail] = useState(appContext.currentUserData.userEmail);

  async function init() {
    //run initializations here
    setReady(false);
    await appContext.getCurrentUserData();
    setReady(true);
  }

  async function updateInfo() {
    if (phone.trim().length === 10) {
      if (email.trim().length > 0) {
        await Promise.all([
          appContext.updateCurrentUserEmail(email),
          appContext.updateCurrentUserPhone(phone),
        ])
      } else {
        appContext.tellError(STR_INVALID_EMAIL[appContext.language]);
      }
    } else {
      appContext.tellError(STR_INVALID_PHONE[appContext.language]);
    }
  }

  useEffect(() => {
    init();
  }, [])



  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
        }}
        className="mNoScrollBar"
      >
        <div className="container">
          <h6
            style={{
              fontSize: "28px",
            }}
            className="font-light mb-4 mt-4"
          >
            {STR_UPDATE_PERSONAL_INFO[appContext.language]}
          </h6>


          <div className="mb-2 mt-2">
            <label className="form=label">{STR_PHONE_NUMBER[appContext.language]}</label>
            <input
              className="form-control"
              onChange={(e) => setPhone(e.target.value)}
              value={phone}
              maxLength={10}
              placeholder="07XXXXXXXX or 06XXXXXXXX"
            />
          </div>

          <div className="mb-2 mt-2">
            <label className="form=label">{STR_EMAIL[appContext.language]}</label>
            <input
              className="form-control"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
          </div>

          <div className="mb-4 mt-4 text-end">
            <button
              className="btn btn-secondary btn-padded btn-rounded"
              onClick={() => {
                appContext.activateDialog({
                  message: STR_SUBMIT[appContext.language] + "?",
                  onConfirm: updateInfo
                })
              }}
            >
              {STR_SUBMIT[appContext.language]}
            </button>
          </div>
        </div>


      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}